import type { IconSvgObject } from './types';

const TradeUpIcon: IconSvgObject = [
  ["path", { d: "M15 8H20V13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 8L13 15L9 11L4 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TradeUpIcon;
